import { FC, Fragment, ReactNode, useRef, useState } from "react"
import { IoMdClose } from "react-icons/io";

type DialogProps = {
	id: string;
	show: boolean;
	onClose: () => void;
	header: string;
	body: ReactNode;
	footer?: ReactNode;
	size?: 'sm' | 'md' | 'lg';
};



const Dialog: FC<DialogProps> = ({ id, show, onClose, header, body, footer, size = 'md' }) => {

	const [isDragging, setIsDragging] = useState(false);
	const DialogRef = useRef<HTMLDivElement>(null);
	const [position, setPosition] = useState({ x: 0, y: 0 });
	const [startPos, setStartPos] = useState({ x: 0, y: 0 });

	const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
		const target = e.target as HTMLElement;
		if (target.closest('button') || target.closest('input')) return;
		if (target.closest('[data-draggable="true"]')) {
			setIsDragging(true);
			setStartPos({
				x: e.clientX - position.x,
				y: e.clientY - position.y,
			});
		}
	};

	const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
		if (!isDragging) return;

		setPosition({
			x: e.clientX - startPos.x,
			y: e.clientY - startPos.y,
		});
	};

	const handleMouseUp = () => {
		setIsDragging(false);
	};

	const sizeClass = size === 'sm' ? 'max-w-md' : size === 'lg' ? 'max-w-3xl' : 'max-w-xl';

	return (show ?
		<Fragment>
			<div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={onClose} />
			<div
				id={id}
				className="flex items-center justify-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
				ref={DialogRef}
				style={{
					transform: `translate(${position.x}px, ${position.y}px)`,
				}}
				onMouseDown={handleMouseDown}
				onMouseMove={handleMouseMove}
				onMouseUp={handleMouseUp}
			>
				<div className={`relative w-auto my-6 mx-auto ${sizeClass}`}>

					<div role="dialog" aria-modal="true" aria-label={header} className="border border-slate-300 rounded-lg shadow-lg shadow-slate-400 hover:shadow-slate-600 relative flex flex-col w-full bg-white outline-none focus:outline-none">

						<div
							data-draggable="true"
							style={{ cursor: isDragging ? "grabbing" : "grab" }}
							className="flex items-start justify-between p-2 border-b border-solid border-slate-200 rounded-t bg-slate-50">
							<h3 className="text-lg font-semibold text-gray-900">
								{header}
							</h3>

							<button
								id={`btn-${id}-close`}
								type="button"
								className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
								data-dialog-hide={id}
								onClick={onClose}
							>
								<IoMdClose />
								<span className="sr-only">Fechar a janela</span>
							</button>
						</div>

						<div>
							{body}
						</div>

						{footer && <div className="flex items-center justify-end py-2 px-6 border-t border-solid border-slate-200 rounded-b">
							{footer}
						</div>}
					</div>
				</div>
			</div>

		</Fragment> : null
	);
}

export default Dialog;